import { RegistrationRevision } from "@faro-lotv/service-wires";
import { Stack } from "@mui/material";
import type { JSX } from "react";
import { PublishButton } from "../inspect-and-publish/publish-button";
import { RegistrationQualityIndicator } from "./registration-quality-indicator";

type DataPreparationActionsProps = {
  /** The revision to publish */
  revision: RegistrationRevision;

  /** Callback, when the report should be opened/closed */
  onToggleReport(shouldOpen: boolean): void;
};

/**
 * @returns The main actions the user can execute in the data preparation page.
 */
export function DataPreparationActions({
  revision,
  onToggleReport,
}: DataPreparationActionsProps): JSX.Element {
  return (
    <Stack direction="row" sx={{ gap: 2, alignItems: "center" }}>
      <RegistrationQualityIndicator onShowReport={() => onToggleReport(true)} />
      <PublishButton
        aria-label="publish registration revision"
        revision={revision}
        disabledDueToError={false}
        showWithWarning={false}
      />
    </Stack>
  );
}
